






















































































import SelectEntity from "@/components/utility/SelectEntity.vue";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { Component } from "vue-property-decorator";
import Card from "../utility/Card.vue";
import PartnerReportCardGeneral from "./PartnerReportCardGeneral.vue";

@Component({
  components: {
    Card,
    SelectEntity
  }
})
export default class PartnerReportCardCompany extends PartnerReportCardGeneral {
  showRemove = false;

  CompanyServiceEnum = CompanyServiceEnum;

  createFilter(service: CompanyServiceEnum): IPageFilterElement[] {
    return [
      new PageFilterElement({
        key: "services",
        operation: PageFilterOperationEnum.EQUAL,
        value: service
      })
    ];
  }

  addTowing(value: string) {
    this.reportDto.towingCompanyId = value;

    if (!value) {
      this.reportDto.towingCompanyId = null;
    }
  }

  addWorkshop(value: string) {
    this.reportDto.workshopCompanyId = value;

    if (!value) {
      this.reportDto.workshopCompanyId = null;
    }
  }

  addInsurance(value: string) {
    this.reportDto.insuranceCompanyId = value;

    if (!value) {
      this.reportDto.insuranceCompanyId = null;
    }
  }

  addAppraiser(value: string) {
    this.reportDto.appraiserCompanyId = value;

    if (!value) {
      this.reportDto.appraiserCompanyId = null;
    }
  }

  addRental(value: string) {
    this.reportDto.rentalCompanyId = value;

    if (!value) {
      this.reportDto.rentalCompanyId = null;
    }
  }

  addAttorney(value: string) {
    this.reportDto.attorneyCompanyId = value;

    if (!value) {
      this.reportDto.attorneyCompanyId = null;
    }
  }
}
